/* Magnolia · Mejoras UX (auditoría oct-2026)
   - Barra «Te faltan $X para el envío gratis» en el carrito lateral (tarea 11).
   - Aviso de personalización por WhatsApp cuando hay joyas personalizables (tarea 1).
   Para cambiar el monto de envío gratis, edita UMBRAL. */
(function () {
  'use strict';
  var UMBRAL = 70000; // CLP
  var PERSO = /relicario|grab|personaliz|con foto|iniciales/i;
  var ICONO = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20 11.5A8.5 8.5 0 0 1 7.6 19L3 20.5l1.5-4.4A8.5 8.5 0 1 1 20 11.5Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  var observer = null, timer = null, busy = false, again = false;

  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(base() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  function render(cart) {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    if (observer) observer.disconnect();

    var head = inner.querySelector('.drawer__header');
    var bar = inner.querySelector('.mj-envio');
    if (!cart.item_count) {
      if (bar) bar.remove();
    } else if (head) {
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'mj-envio';
        bar.setAttribute('role', 'status');
        head.insertAdjacentElement('afterend', bar);
      }
      var total = cart.total_price / 100;
      var falta = UMBRAL - total;
      var pct = Math.max(4, Math.min(100, Math.round((total / UMBRAL) * 100)));
      bar.innerHTML = (falta > 0
        ? 'Te faltan <strong>' + fmt(falta) + '</strong> para el <strong>envío gratis</strong>.'
        : '¡Listo! Tu pedido tiene <strong>envío gratis</strong>.') +
        '<div class="mj-envio__barra" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
    }

    var ctas = inner.querySelector('.drawer__footer .cart__ctas');
    var nota = inner.querySelector('.mj-wsp-nota');
    var perso = (cart.items || []).some(function (i) { return PERSO.test(i.product_title || '') || PERSO.test(i.title || ''); });
    if (!perso) {
      if (nota) nota.remove();
    } else if (ctas && !nota) {
      nota = document.createElement('p');
      nota.className = 'mj-wsp-nota';
      nota.innerHTML = ICONO + '<span>Tu joya es personalizada: después de pagar te escribimos por <strong>WhatsApp</strong> para recibir tu foto o tu texto y enviarte el diseño para aprobar. <strong>Deja tu número al pagar.</strong></span>';
      ctas.insertAdjacentElement('beforebegin', nota);
    }
    observe();
  }

  function observe() {
    var el = document.getElementById('CartDrawer');
    if (!el || !window.MutationObserver) return;
    if (!observer) observer = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 120); });
    observer.observe(el, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 150); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
